import type { components, operations, paths } from './api/commerceApi'
export { components, paths }

/** the (url) paths for the CommerceEngineApi  */
export type CommerceEngineApiPaths = keyof paths

/**
 * the CommerceEngineOpenApiFetchClient (see @toni/commerce-api-client) uses fetch and will return one of the following
 */
export type ApiFetchResponse<TData = unknown, TError = unknown> =
  | {
      data: TData,
      error?: never,
      response: Response
  }
  | {
      data?: never,
      error: TError,
      response: Response
  };

export enum CURRENCY {
  GBP = 'GBP',
  EUR = 'EUR',
  USD = 'USD'
}

export enum ProductIdType {
  ASIN = 'Amazon Product ASIN',
  URL = 'Url'
}

export enum SUPPORTED_MARKETS {
  GB = 'GB',
  US = 'US',
  DE = 'DE'
}

export type GetThirdPartyProductsRequest = components['schemas']['GetThirdPartyProductsRequestDto']

export type ProductCard = components['schemas']['BauerProductCardResponseDto']
export type BauerProductCard = components['schemas']['BauerProductCardResponseDto']['bauerProductCard']
export type BauerProduct = components['schemas']['BauerProductCardResponseDto']['bauerProduct']
export type BauerProductCardLinks = components['schemas']['BauerProductCardResponseDto']['bauerProductCardLinks']

export type ProductCardWithThirdPartyProducts = components['schemas']['BauerProductCardWithProductsResponseDto']
export type Images = ProductCardWithThirdPartyProducts['bauerProductCard']['images']
export type IntendedUses = ProductCardWithThirdPartyProducts['bauerProductCard']['intendedUses']

export type ThirdPartysProductResponse = components['schemas']['ThirdPartyProductsResponseDto']

export type ProsCons = components['schemas']['BauerProductCardResponseDto']['bauerProductCard']['pros']

export type ProductIds = components['schemas']['BauerProductCardResponseDto']['bauerProduct']['productIds']
export type ProductId = ProductIds[0]

export type ThirdPartyProduct = components['schemas']['BauerProductCardWithProductsResponseDto']['thirdPartyProducts'][0]
export type ThirdPartyProducts = components['schemas']['BauerProductCardWithProductsResponseDto']['thirdPartyProducts']

export type CreateProductCardRequest = components['schemas']['CreateBauerProductCardRequestDto']
export type CreateProductCardDraft = components['schemas']['CreateBauerProductCardRequestDto'] & {thirdPartyProducts: ThirdPartyProducts}
export type EditProductCardDraft = ProductCardWithThirdPartyProducts

export type GetProductCardWithPurchaseOptionsByIdParams = paths['/content-delivery/get-product-cards']['post']['requestBody']['content']['application/json']
export type ProductCardWithPurchaseOptions = components['schemas']['GetBauerProductCardWithPurchaseOptionsResponseDto']
export type PurchaseOptions = components['schemas']['GetBauerProductCardWithPurchaseOptionsResponseDto']['purchaseOptions']

export type ProductCardLayout = components['schemas']['GetBauerProductCardWithPurchaseOptionsResponseDto']['layout']
export type SearchBauerProductCardsResponse = components['schemas']['SearchBauerProductCardsResponseDto']
export type SearchBauerProductCardsRequest = operations['CommerceManagementController_searchProductCards']['parameters']['query']

export type GetOrAssignTrackingIdForAffiliatePublisherNodeRequest = operations['AffiliatePublisherNodeTrackingController_getOrAssignTrackingIdForAffiliatePublisherNode']['requestBody']['content']['application/json']
export type GetOrAssignTrackingIdForAffiliatePublisherNodeResponse = ApiFetchResponse<operations['AffiliatePublisherNodeTrackingController_getOrAssignTrackingIdForAffiliatePublisherNode']['responses']['200']['content']['application/json']>

export type GetAffiliateLinkUrlMappingsRequest = operations['AffiliatePublisherNodeTrackingController_getAffiliateLinkUrlMappings']['requestBody']['content']['application/json']
export type GetAffiliateLinkUrlMappingsResponse = ApiFetchResponse<operations['AffiliatePublisherNodeTrackingController_getAffiliateLinkUrlMappings']['responses']['200']['content']['application/json']>

export type Merchants = components['schemas']['SearchBauerMerchantsResponseDto']
export type Merchant = Merchants['items'][0]['bauerMerchant']

export type ManualPurchaseOptions = components['schemas']['BauerProductCardResponseDto']['bauerProductCard']['manualPurchaseOptions']
export type AffiliatePublisherNodeRelatedDataUpdatedMessage = components['schemas']['AffiliatePublisherNodeRelatedDataUpdatedMessage']

export type GetProductCardVariantsRequest = operations['CommerceManagementController_getProductCardVariants']['parameters']['query']
export type GetProductCardVariantsResponse = ApiFetchResponse<operations['CommerceManagementController_getProductCardVariants']['responses']['200']['content']['application/json']>
